import ColumnName from './ColumnName';
import ColumnTypeData from './ColumnType';
import ForeignKey from './ForeignKey';

class Column {
  readonly _name: ColumnName;

  readonly _type: ColumnTypeData;

  readonly _fks: ForeignKey[];

  constructor(name: ColumnName, type: ColumnTypeData, fks: ForeignKey[]) {
    this._name = name;
    this._type = type;
    this._fks = fks;
  }

  static build(c: Column) {
    return new Column(
      ColumnName.build(c._name),
      ColumnTypeData.build(c._type),
      c._fks.map((fk) => ForeignKey.build(fk)),
    );
  }

  name() {
    return this._name;
  }

  type() {
    return this._type;
  }

  fks() {
    return this._fks;
  }
}

export default Column;
